import React from "react";
import BottomSheet from "./BottomSheet";
import css from "./partnersMobile.module.css";

// Confirms Approve from the detail page's action bar, where one tap would
// otherwise approve immediately. Reject and Suspend need no sheet: both open
// the RejectReason modal, which is its own confirmation step (it asks for a
// reason and has Cancel), exactly as on desktop.
const COPY = {
  approve: {
    title: (name) => `Approve ${name}`,
    body: "The partner is verified and gains access to the partner portal.",
    confirm: "Approve partner",
    className: "btnPrimary",
  },
};

export default function ConfirmSheet({ open, action, name, onConfirm, onCancel }) {
  const copy = COPY[action];
  if (!copy) return null;

  return (
    <BottomSheet
      open={open}
      title={copy.title(name)}
      onClose={onCancel}
      footer={
        <>
          <button
            type="button"
            className={`${css.btn} ${css.btnSecondary}`}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`${css.btn} ${css[copy.className]}`}
            onClick={onConfirm}
          >
            {copy.confirm}
          </button>
        </>
      }
    >
      <p style={{ margin: 0, fontSize: 14, lineHeight: "20px", color: "#667085" }}>
        {copy.body}
      </p>
    </BottomSheet>
  );
}
